var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui main container"},[_c('LoginForm',{attrs:{"message":_vm.message,"isLoading":_vm.loading,"showRegisterButton":true},on:{"onLogin":_vm.login,"onRegister":_vm.signup}}),_c('div',{staticClass:"ui"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }